import { BarChart3 } from "lucide-react";
import { useTranslation } from "@ncp/i18n";
import { CatalogPage } from "../features/generic/CatalogPage";
import { newReportBody, type ReportBody } from "../features/reports/api";
import type { DefinitionSummary } from "../features/generic/api";

/** Reports: tables and charts an admin defines over records or cases, exported as CSV or Excel. */
export function ReportsPage() {
  const { t } = useTranslation();
  return (
    <CatalogPage<DefinitionSummary, ReportBody>
      resource="reports"
      basePath="/reports"
      icon={BarChart3}
      title={t("admin:reports.title")}
      subtitle={t("admin:reports.subtitle")}
      navLabel={t("admin:nav.reports")}
      writePermission="platform.reports.write"
      newLabel={t("admin:reports.new")}
      emptyTitle={t("admin:reports.emptyTitle")}
      emptyBody={t("admin:reports.emptyBody")}
      docsAnchor="reports"
      help={<><p>{t("admin:reports.help.what")}</p><p>{t("admin:reports.help.export")}</p></>}
      newBody={newReportBody}
    />
  );
}
